import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HTTP_INTERCEPTORS
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private currentRequests: number;
  constructor(private spinnerService: NgxSpinnerService) {
    this.currentRequests = 0;
  }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const loadingHeader = request.headers.get('showLoading');
    console.log('loadingHeader', loadingHeader);

    if (loadingHeader) {
        const showLoading: boolean = JSON.parse(loadingHeader);
        if (showLoading) {
            this.incrementRequestCount();
        }
    } else {
        this.incrementRequestCount();
    }

    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (loadingHeader) {
                const showLoading: boolean = JSON.parse(loadingHeader);
                if (showLoading) {
                    this.decrementRequestCount();
                }
            } else {
                this.decrementRequestCount();
            }
          }
        },
        (err: any) => {
          this.currentRequests = 0;
          this.spinnerService.hide();
        }
      )
    );
  }

  private decrementRequestCount() {
    if (--this.currentRequests === 0) {
      this.spinnerService.hide();
    }
  }

  private incrementRequestCount() {
    if (this.currentRequests++ === 0) {
      //bring spinner only after 1/2 sec. and the request is still incomplete
      setTimeout(() => {
        // if (this.currentRequests !== 0) this.spinnerService.show();
      }, 500);
    }
  }
}

export const LoaderInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: LoaderInterceptor,
  multi: true
};



// WEBPACK FOOTER //
// ./src/app/core/interceptors/loading.interceptor.ts